// ────────────────────────────
// src/components/OverviewSection.jsx
// ────────────────────────────
import React from "react";
import "./OverviewSection.css";
import dashboardImg from "../assets/images/dashboard-screenshots/dashboard-clients.png";
import iphoneMockup from "../assets/images/mobile-screenshots/mobile-home.png";

export default function OverviewSection() {
  return (
    <section className="overview-section rel bg-gray pt-0 pb-0 rpb-0">
      {/* lienzo ancho */}
      <div className="container-xxl position-relative">

        {/* fila flex centrada */}
        <div className="overview-row justify-content-center align-items-start">

          {/* ① DASHBOARD */}
          <div className="overview-dashboard-col">
            <img
              src={dashboardImg}
              alt="Dashboard"
              className="img-fluid w-100 overview-dashboard"
            />
          </div>

          {/* ② MOBILE */}
          <div className="overview-mobile-col">

            <img
              src={iphoneMockup}
              className="iphone-mockup mb-30"
              alt="Vista iPhone"
            />

            <div className="d-flex gap-2 flex-wrap justify-content-start">
              <img
                src="https://zifit.io/static/media/app-store-badge.png"
                className="store-badge"
                alt="Disponible en App Store"
              />
              <img
                src="https://zifit.io/static/media/google-play-badge.png"
                className="store-badge"
                alt="Disponible en Google Play"
              />
            </div>
          </div>
        </div>
      </div>

      {/* forma decorativa existente */}
      <div className="bg-yellow-shape" />
    </section>
  );
}
